import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { classNames } from '../../utils/classNames';
import { useI18n } from '../../hooks/useI18n';

export const PricingFaq = () => {
  const { t } = useI18n();
  const items = t('pricingFaq') || [];
  const [openIndex, setOpenIndex] = useState(0);

  if (!items.length) {
    return null;
  }

  return (
    <section className="mx-auto mt-20 max-w-3xl" aria-labelledby="pricing-faq-title">
      <h2 id="pricing-faq-title" className="text-center text-3xl font-black tracking-[-0.04em] text-text">
        {t('pricingFaqTitle')}
      </h2>
      <div className="mt-8 divide-y divide-border overflow-hidden rounded-[1.75rem] border border-border bg-panel/80 backdrop-blur-xl dark:bg-panel">
        {items.map((item, index) => {
          const open = openIndex === index;
          return (
            <div key={item.question}>
              <button
                type="button"
                aria-expanded={open}
                onClick={() => setOpenIndex(open ? -1 : index)}
                className="flex min-h-14 w-full cursor-pointer items-center justify-between gap-4 px-5 py-4 text-start"
              >
                <span className="text-sm font-bold text-text sm:text-base">{item.question}</span>
                <ChevronDown
                  size={18}
                  className={classNames(
                    'shrink-0 text-muted transition duration-200',
                    open ? 'rotate-180 text-text' : ''
                  )}
                  aria-hidden
                />
              </button>
              {open ? (
                <p className="px-5 pb-5 text-sm leading-7 text-muted">{item.answer}</p>
              ) : null}
            </div>
          );
        })}
      </div>
    </section>
  );
};
